import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostBinding,
  input,
} from '@angular/core';
import { SscButtonDirective } from '../../../directives/button.directive';
import { ActiveDirective } from '../../../directives';

export enum SscButtonHierarchy {
  brand = 'brand',
  primary = 'primary',
  basic = 'basic',
  link = 'link',
  inverted = 'inverted',
  bordered = 'bordered',
}

@Component({
  selector: 'button[ssc-button], a[ssc-button]',
  templateUrl: './ssc-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'transition-colors duration-200',
    '[class]': 'classes()',
  },
  hostDirectives: [
    {
      directive: SscButtonDirective,
      inputs: ['size'],
    },
    {
      directive: ActiveDirective,
      inputs: ['activeScale'],
    },
  ],
})
export class SscButtonComponent {
  disabled = input<boolean>(false);

  @HostBinding('attr.disabled')
  get disabledAttr(): '' | null {
    return this.disabled() ? '' : null;
  }

  hierarchy = input<SscButtonHierarchy>(SscButtonHierarchy.basic);

  classes = computed(() => {
    if (this.disabled()) {
      return `font-medium cursor-not-allowed bg-surface-light/50 dark:bg-surface-dim/50 text-text-dark/30 dark:text-text-faint/30`;
    }
    switch (this.hierarchy()) {
      case SscButtonHierarchy.brand:
        return `font-medium bg-brand dark:bg-brand-faint hover-layer text-text-faint dark:text-text-dark border dark:border-border-dark border-border-soft border-solid`;
      case SscButtonHierarchy.primary:
        return `font-medium bg-primary dark:bg-primary-faint hover-layer text-text-faint dark:text-text-dark`;
      case SscButtonHierarchy.inverted:
        return `font-medium bg-surface-faint dark:bg-surface-dark hover-layer text-text-dark dark:text-text-faint`;
      case SscButtonHierarchy.basic:
        return `font-medium hover-layer text-text-dark dark:text-text-faint `;
      case SscButtonHierarchy.bordered:
        return `font-medium border border-border-soft dark:border-border-dark border-solid hover-layer text-text-dark dark:text-text-faint backdrop-blur-lg`;
      case SscButtonHierarchy.link:
        return `font-medium hover:underline text-text-dark dark:text-text-faint`;
      default:
        return '';
    }
  });
}
